export const iconFontAwesomeFilmVideoMicrophoneLines = (
	<i className="fa-solid fa-microphone-lines"></i>
);
